import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { CompanyDocumentosFiscaisManager } from './CompanyDocumentosFiscaisManager';

export interface CompanyDocumentosFiscaisDialogProps {
  open: boolean;
  companyId: number | null;
  companyName?: string;
  /** Se true, CST/tipoRetencao PIS-COFINS não se aplicam (regra RPS v2.0). */
  simplesNacional?: boolean;
  onClose: () => void;
}

/** Wrapper Dialog em torno de `CompanyDocumentosFiscaisManager`. */
export function CompanyDocumentosFiscaisDialog({
  open,
  companyId,
  companyName,
  simplesNacional = false,
  onClose,
}: CompanyDocumentosFiscaisDialogProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {companyName
          ? t('features.empresa.documentosFiscais.dialogTitleNamed', { nome: companyName })
          : t('features.empresa.documentosFiscais.dialogTitle')}
        <IconButton onClick={onClose} aria-label={t('common.close')} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {companyId !== null && (
          <CompanyDocumentosFiscaisManager
            companyId={companyId}
            simplesNacional={simplesNacional}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
